import { CategoryRepository } from "../Repository/CategoryRepository";



export interface DeleteCategoryUseCase {
    invoke: (id: string) => Promise<boolean>;
  }
  
  export class RemoveCategory implements DeleteCategoryUseCase {
    private categoryRepo: CategoryRepository;
    constructor(_CategoryRepo: CategoryRepository) {
      this.categoryRepo = _CategoryRepo;
    }
  
    async invoke(id: string){
       
        if(!id){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const deleted  = await this.categoryRepo.removeCategory(id);
        return deleted;
    }
  }